export default __webpack_public_path__ + "static/media/large_van_purple.3795e40b.svg";